import axios from "axios";

import config from "../frontend.config.json";

const BACKEND_ORIGIN = config.BACKEND_ORIGIN;

const VisitAPI = {
  getVisitList: async (token, queryParams) => {
    return axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/visit/list`,
      headers: { Authorization: token },
      params: { ...queryParams },
    });
  },
  getVisitListResume: async (token, queryParams = {}) => {
    return axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/visit/list/resume`,
      headers: { Authorization: token },
      params: { ...queryParams },
    });
  },
  downloadVisitReport: async (token, queryParams) => {
    return axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/visit/report/download`,
      headers: { Authorization: token },
      params: { ...queryParams },
      responseType: "blob",
    });
  },
  getHTMLVisitReport: async (token, queryParams) => {
    return axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/visit/report/print`,
      headers: { Authorization: token },
      params: { ...queryParams },
    });
  },
  getVisitFiles: async (token, id) => {
    return axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/visit/files/${id}`,
      headers: { Authorization: token },
    });
  },
};

export default VisitAPI;
